<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates16">
<p class="centerImage"><img alt="images" id="plate16" src="images/plate16.jpg"/></p>
<p class="caption">Peter Parrott was already a combat veteran when he joined 605 Squadron in September 1940. This picture of him was taken and used for a recruitment poster early in the war. He later flew successfully in Italy 1943-44.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates16.vue?122bdad8